import { FC, HTMLProps } from 'react'
import { cn } from '@/lib/utils'
interface ShadowBlockProps extends HTMLProps<HTMLDivElement> {
	type: 'bottom' | 'bottom-right'
}

export const ShadowBlock: FC<ShadowBlockProps> = ({ type, ...rest }) => {
	const shadowStyle = type === 'bottom' ? 'shadow-bottom' : 'shadow-bottom_right'

	return (
		<div {...rest} className={cn(`${shadowStyle} mr-1 mb-1 rounded-xl`, rest.className)}>
			{rest.children}
		</div>
	)
}
